import React from 'react';

const AccountPlayersPreviewHeader = () => {
  return (
    <thead>
      <tr>
        <th>Id</th>
        <th>Name</th>
        <th>Cohort</th>
        <th>Age Range</th>
        <th>Created At</th>
        <th>Type</th>
      </tr>
    </thead>
  );
}

export default AccountPlayersPreviewHeader;
